import * as http from 'utils/http';
import {
  createOrUpdateVehicle,
  removeVehicle as RemoveVehicleReducer,
} from 'redux/modules/carrier-section/duck';

export const createVehicle = (vehicle) => {
  return (dispatch, getState, config) => {
    return http
      .post(config.API_URL + 'vehicles/', {
        ...vehicle,
      })
      .catch((err) => {
        throw err;
      })
      .then((response) => dispatch(createOrUpdateVehicle(response)));
  };
};

export const updateVehicle = (vehicle) => {
  return (dispatch, getState, config) => {
    return http
      .patch(`${config.API_URL}vehicles/${vehicle.id}/`, vehicle)
      .catch((err) => {
        throw err;
      })
      .then((response) => {
        dispatch(createOrUpdateVehicle(response));
      });
  };
};

export const removeVehicle = (vehicle) => {
  return (dispatch, getState, config) => {
    return http
      .post(`${config.API_URL}vehicles/${vehicle.id}/remove/`, vehicle)
      .then((response) => {
        dispatch(RemoveVehicleReducer(response));
        return response;
      })
      .catch((err) => {
        throw err;
      });
  };
};
